import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import * as actionTypes from '../../../../store/actions/actionTypes';
import pdfSvg from '../../../../assets/images/pdf.svg';

const AdmissionList_Item_ManagerCustomUI_UploadPdf = ({admission, customUI}) => {
    const idToken = useSelector(state => state.auth.idToken);
    const dispatch = useDispatch();
    const showUploadModal = () => dispatch({type: actionTypes.MODAL_CUSTOM_UI_UPLOAD_PDF_SHOW, admission, customUI})
    const showPreviewModal = () => dispatch({type: actionTypes.MODAL_CUSTOM_UI_UPLOAD_PREVIEW_PDF_SHOW, admission, customUI})
    const downloadFile = event => {
        event.preventDefault();
        event.stopPropagation();
        ref.current.submit();
    }
    const ref = React.useRef();

    // The row may still belong to the previously selected hospital while the
    // columns are already rendered from the new one - its manager_customUI map
    // has no entry for this customUI id then. Render the neutral state instead
    // of crashing the whole list (IMP-889).
    const uiData = (admission.manager_customUI || {})[customUI.id] || {};

    if(uiData.status) {
        // In multiple-uploads mode the button opens the manage modal (list of
        // files with add/remove) instead of previewing/downloading a single PDF.
        const onFileButtonClick = customUI.multipleUploads
            ? showUploadModal
            : (customUI.showPdfInPopup ? showPreviewModal : downloadFile);

        // Show a counter badge when several files are uploaded.
        const filesCount = customUI.multipleUploads
            ? (uiData.files || []).length
            : 0;
        // The badge sits inside the button, so its click bubbles up to the
        // button's onClick - no separate handler needed here.
        const counterBadge = filesCount > 1
            ? <span className="badge-counter">{filesCount}</span>
            : null;
        const baseClass = customUI.largeButtonInList ? "btn-pink btn btn-success10 text-success" : "btn-pink btn-sm btn btn-success10 text-success";

        return <>
            <button className={counterBadge ? `${baseClass} btn-with-badge-counter` : baseClass} onClick={onFileButtonClick}>{counterBadge}<img src={pdfSvg} /></button>
            <div className="display-none">
                <form action={`${process.env.REACT_APP_API_PATH}/admission/${admission.id}/custom-ui/${customUI.id}/download-pdf`} method="post"
                      ref={ref}>
                    <input type="hidden" name="token" value={idToken}/>
                </form>
            </div>
        </>
    }

    return <button className={customUI.largeButtonInList ? "btn-group-table-button btn btn-gray10" : "btn-group-table-button btn btn-sm btn-gray10"} onClick={showUploadModal}>-</button>
}

export default AdmissionList_Item_ManagerCustomUI_UploadPdf;